import * as React from "react";
import PropTypes from "prop-types";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import BuySellTab from "./BuySellTab";
import useAuth from "../../../../hooks/useAuth";

const drawerBleeding = 56;

const Root = styled("div")(({ theme }) => ({
	height: "100%",
	backgroundColor: grey[100],
	...theme.applyStyles("dark", {
		backgroundColor: (theme.vars || theme).palette.background.default,
	}),
}));

const StyledBox = styled("div")(({ theme }) => ({
	backgroundColor: "#fff",
	...theme.applyStyles("dark", {
		backgroundColor: grey[800],
	}),
}));

const Puller = styled("div")(({ theme }) => ({
	width: 30,
	height: 6,
	backgroundColor: grey[300],
	borderRadius: 3,
	position: "absolute",
	top: 8,
	left: "calc(50% - 15px)",
	...theme.applyStyles("dark", {
		backgroundColor: grey[900],
	}),
}));

const BuySellDrawerUtil = React.memo((props) => {
	const { window, coinName, coinSymbol, coinImage, coinPrice } = props;
	const [open, setOpen] = React.useState(false);
	// const { setAuth } = useAuth();

	// setAuth((prev) => ({ ...prev, crypto_symbol: coinSymbol }));
	// console.log(coinPrice);
	// const { setAuth } = useAuth();
	// setAuth((auth) => ({ ...auth, coinPrice }));
	// console.log(auth);
	const toggleDrawer = React.useCallback(
		(newOpen) => () => {
			setOpen(newOpen);
		},
		[]
	);

	const container =
		window !== undefined ? () => window().document.body : undefined;

	return (
		<Root>
			<CssBaseline />
			<Global
				styles={{
					".MuiDrawer-root > .MuiPaper-root": {
						height: `calc(80% - ${drawerBleeding}px)`,
						overflow: "visible",
					},
				}}
			/>
			<Box sx={{ textAlign: "left", pt: 1 }}>
				<Button
					onClick={toggleDrawer(true)}
					sx={{
						width: "100%",
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						px: 2,
					}}
					aria-label={`Open drawer for ${coinName}`}>
					<Typography sx={{ fontSize: 16 }} color="text.primary">
						{coinName} {`(${coinSymbol})`}
					</Typography>
					<img
						src={coinImage}
						alt={`${coinName}`}
						className="h-[2rem] w-[2rem]"
					/>
				</Button>
			</Box>
			<SwipeableDrawer
				container={container}
				anchor="bottom"
				open={open}
				onClose={toggleDrawer(false)}
				onOpen={toggleDrawer(true)}
				swipeAreaWidth={drawerBleeding}
				disableSwipeToOpen={false}
				keepMounted>
				<StyledBox
					sx={{
						position: "absolute",
						top: -drawerBleeding,
						borderTopLeftRadius: 8,
						borderTopRightRadius: 8,
					}}>
					<Puller />
					<Box sx={{ display: "flex", alignItems: "center", pr: "1rem" }}>
						<Typography sx={{ p: 2, color: "text.secondary" }}>
							{coinName}
						</Typography>
						<img
							src={coinImage}
							alt={`${coinName}`}
							className="h-[2rem] w-[2rem]"
						/>
					</Box>
				</StyledBox>
				<StyledBox sx={{ px: 2, pb: 2, height: "100%", overflow: "auto" }}>
					{/* No longer passing searchQuery */}
					<BuySellTab coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</StyledBox>
			</SwipeableDrawer>
		</Root>
	);
});

BuySellDrawerUtil.propTypes = {
	window: PropTypes.func,
	coinName: PropTypes.string.isRequired,
	coinSymbol: PropTypes.string.isRequired,
	coinImage: PropTypes.string.isRequired,
};

export default BuySellDrawerUtil;
